import { Tabs as LibTabs } from "@mui/material";

import { isSmallDesktop } from "@hooks/layout";

import styled, { css } from "styled-components";

type TTabs = {
  $isCatalog: boolean;
  $isFirstTabSelected: boolean;
};
export const Tabs = styled(LibTabs)<TTabs>`
  &.MuiTabs-root {
    height: 100%;
  }
  && {
    .MuiTabs-flexContainer {
      height: 100%;

      ${($isCatalog) =>
        $isCatalog &&
        `
        .MuiTab-root{
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 6px;

          .MuiTab-iconWrapper {
            margin: 0;
          }

          svg {
            width: 20px;
            height: 20px;

            path{
              fill:#e3bda0;
            }
          }

          &[aria-selected="true"] {
            svg path{
                fill:#fbf4ec;
              }
            ${isSmallDesktop}{
              .MuiTab-iconWrapper {
                margin: 0 0 2px 0;
              }
            }
          }
        }

      .track {
        transform: translateY(2px) ;
      }

      .album, .filter {
        transform: translateY(-1px) ;
      }

      &:has(.MuiTab-root:nth-child(1)[aria-selected="true"]) .MuiTab-root:nth-child(3) {
        margin: 0 0 0 1px;
      }

      &:has(.MuiTab-root:nth-child(3)[aria-selected="true"]) .MuiTab-root:nth-child(1) {
        margin: 0 1px 0 0;
      }
        
      `}

      .MuiTab-root {
        height: 100%;
        position: relative;
        flex: 1;
        max-width: 100%;

        border-bottom: 1px solid #ffdca8;

        ${({ $isCatalog }) =>
          $isCatalog &&
          css`
            border-bottom: 1px solid #9b8166;
          `}

        font: 1.125rem/135% "Kaisei Opti", sans-serif;

        color: #e3bda0;
        text-transform: uppercase;

        border-radius: 8px 8px 0 0;

        background-color: rgba(75, 55, 39, 0.5);

        min-width: 200px;
        min-height: 49px;

        ${({ $isCatalog }) =>
          $isCatalog &&
          `
           &:hover {
          background: #59422e;
        }
          `}

        &[aria-selected="true"] {
          color: #fbf4ec;
          border: 1px solid #ffdca8;
          border-bottom: none;
          background-color: rgba(59, 45, 33, 0.2);
          ${({ $isCatalog, $isFirstTabSelected }) =>
            $isCatalog &&
            css`
              border: 1px solid #9b8166;
              border-bottom: none;
              ${$isFirstTabSelected ? "border-left" : "border-right"}: none;
            `}
        }
        &:nth-child(2)[aria-selected="true"] {
          border-right: 1px solid #9b8166;
        }
      }
    }

    .MuiTabs-indicator {
      display: none;
    }

    ${isSmallDesktop} {
      ${({ $isCatalog }) =>
        $isCatalog &&
        `&& {
        .MuiTabs-flexContainer .MuiTab-root {
          font-family: Raleway;
          font-weight: 100;
          font-size: 0.9rem;
        }
      }`}
    }
  }
`;
